import script from "./Review.vue?vue&type=script&setup=true&lang=js"
export * from "./Review.vue?vue&type=script&setup=true&lang=js"

import "./Review.vue?vue&type=style&index=0&id=6f22ce80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f22ce80"]])

export default __exports__